const pattern = /---uniform-setting-locale=(\w+)/;
export const getCurrentLanguage = () => {
    const [, lang] = document.cookie.match(pattern) || [];
    if (!lang) {
        const host = window.location.host || '';
        if (host.indexOf('.zhihuiya.') > -1) {
            return 'cn';
        }
        if (host.indexOf('.patsnap.') > -1) {
            return 'en';
        }
        return 'en';
    }
    return lang;
};
